import React from 'react';
import PropTypes from 'prop-types';

import MaterialForm from 'admin-moderator/components/MaterialForm';
import MaterialHeaderInfo from 'admin-moderator/components/MaterialHeaderInfo';

import Wrapper from './Wrapper';

export class MaterialHeader extends React.PureComponent {
  state = {
    isOpenEdit: false,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.setState({
        isOpenEdit: false,
      });
    }
  }

  handleEditOpen = () => {
    this.setState({ isOpenEdit: true });
  }

  handleEditClose = () => {
    this.setState({ isOpenEdit: false });
  }

  handleFormSubmit = (data) => {
    this.handleEditClose();

    this.props.onFormSubmit(data);
  }

  render() {
    return (
      <Wrapper>
        {this.state.isOpenEdit
          ? (
            <MaterialForm
              title={this.props.title}
              description={this.props.description}
              price={this.props.price}
              onClose={this.handleEditClose}
              onSubmit={this.handleFormSubmit}
              status={this.props.status}
            />
          ) : (
            <MaterialHeaderInfo
              title={this.props.title}
              mediaType={this.props.mediaType}
              description={this.props.description}
              createdAt={this.props.createdAt}
              duration={this.props.duration}
              price={this.props.price}
              onEditClick={this.handleEditOpen}
              backPath="/materials"
            />
          )
        }
      </Wrapper>
    );
  }
}

MaterialHeader.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  mediaType: PropTypes.oneOf(['video', 'image']),
  description: PropTypes.string,
  createdAt: PropTypes.number,
  duration: PropTypes.number,
  price: PropTypes.number,
  onFormSubmit: PropTypes.func,
  status: PropTypes.oneOf(['created', 'accepted', 'rejected']),
};

MaterialHeader.defaultProps = {
  title: '',
  mediaType: 'image',
  description: '',
  createdAt: undefined,
  duration: 0,
  price: 0,
  onFormSubmit: () => {},
  status: 'created',
};

export default MaterialHeader;
